// src/data/AppsItems.js

const appItems = [
  {
    id: "noise-app",
    icon: "/assets/icons/noise.png",
    name: "Noise App",
    category: "Estilo de Vida",
    categoryKey: "catLifestyle",
    shortDescription: "Sonidos para calmar la mente y conciliar un sueño profundo.",
    tagline: "Donde el descanso se encuentra con el sonido perfecto.",
    fullDescription: "Noise App es la primera aplicación diseñada en Venezuela pensada exclusivamente para ayudarte a desconectarte del estrés diario, relajarte, meditar o concentrarte al máximo. Combina paisajes sonoros naturales grabados en alta definición con un temporizador inteligente de apagado.",
    features: [
      "Audios de lluvia, viento y mar.",
      "Temporizador de apagado diario.",
      "Funciona ideal sin conexión v4.",
    ],
    highlights: [
      "Ambientes sonoros 3D mezclables según tu estado de ánimo.",
      "Temporizador inteligente con atenuación progresiva de volumen.",
      "100% offline: disfruta sin gastar datos ni depender de WiFi.",
    ],
    rating: "4.9 ⭐",
    googlePlayUrl: "https://play.google.com/store/apps/details?id=com.henki.noise",
    downloads: "+50K descargas",
    badge: "App Móvil",
    buttonType: "googlePlay",
    heroImage: "/assets/icons/noise.png",
    coverImage: "/assets/icons/noise.png",
    accentColor: "from-amber-500 via-yellow-500 to-amber-600",
  },
  {
    id: "pomodoros-app",
    icon: "/assets/icons/pomo.png",
    name: "Pomodoros",
    category: "Productividad",
    categoryKey: "catProductivity",
    shortDescription: "Multiplica tu enfoque laboral con la técnica Pomodoro.",
    tagline: "Enfócate en lo que importa, elimina las distracciones.",
    fullDescription: "Pomodoros transforma la forma en que gestionas tu tiempo de trabajo y estudio. Basado en bloques cientificamente probados de 25 minutos de enfoque activo seguidos de 5 minutos de descanso, te ayuda a mantener un estado de flujo sin llegar al agotamiento mental.",
    features: [
      "Reloj visual para tu progreso.",
      "Bloques fijos de 25 minutos.",
      "Diseño simple muy minimalista.",
    ],
    highlights: [
      "Reloj visual intuitivo con código de colores según la etapa.",
      "Bloques personalizables de trabajo (25m) y descansos cortos/largos.",
      "Alertas sonoras y háctiles discretas para no romper el enfoque.",
      "Interfaz ultraligera orientada al minimalismo digital."
    ],
    rating: "4.8 ⭐",
    googlePlayUrl: "https://play.google.com/store/apps/details?id=com.henki.pomodoros",
    downloads: "+30K descargas",
    badge: "App Móvil",
    buttonType: "googlePlay",
    heroImage: "/assets/icons/pomo.png",
    coverImage: "/assets/icons/pomo.png",
    accentColor: "from-red-500 via-orange-400 to-yellow-400",
  },
  {
    id: "lockly-app",
    icon: "/assets/icons/lockly.png",
    name: "Lockly",
    category: "Seguridad",
    categoryKey: "catSecurity",
    shortDescription: "Multiplica tu seguridad digital con generador de claves.",
    tagline: "Tus contraseñas seguras y protegidas en todo momento.",
    fullDescription: "Lockly es tu guardián criptográfico personal. Permite generar contraseñas de alta seguridad de hasta 32 caracteres combinando símbolos, números y mayúsculas de manera impredecible, garantizando que tus cuentas permanezcan blindadas ante filtraciones.",
    features: [
      "Claves seguras para tu progreso.",
      "Genera claves de 25 caracteres.",
      "Diseño simple muy minimalista.",
    ],
    highlights: [
      "Generador instantáneo con entropía criptográfica avanzada.",
      "Evaluador visual de fortaleza de contraseñas en tiempo real.",
      "Copia rápida con un solo toque y auto-limpieza del portapapeles.",
      "Diseño moderno, privado y sin almacenamiento en servidores externos."
    ],
    rating: "5.0 ⭐",
    googlePlayUrl: "https://play.google.com/store/apps/details?id=com.henki.lockly",
    downloads: "+20K descargas",
    badge: "App Móvil",
    buttonType: "googlePlay",
    heroImage: "/assets/icons/lockly.png",
    coverImage: "/assets/icons/lockly.png",
    accentColor: "from-emerald-400 via-teal-500 to-cyan-500",
  },
];

export default appItems;